export default "__VITE_ASSET__CFH0P9_v__"